/**
 * Resolve the Taruvi API base URL for the current environment.
 *
 * Priority:
 * 1. *.localhost hostnames → http://{hostname}:8000
 * 2. Production → https://{first-label}.taruvibase.cloud
 */
export function resolveApiUrl(): string {
  const { hostname, protocol } = window.location;

  if (hostname === 'localhost' || hostname.endsWith('.localhost')) {
    return `${protocol}//${hostname}:8000`;
  }

  const subdomain = hostname.split('.')[0];
  return `https://${subdomain}.taruvibase.cloud`;
}
